import React from "react";
import TranslationsConstructor from "./TranslationsConstructor.jsx";

const Translations = TranslationsConstructor(React);
export default Translations;
